export default __webpack_public_path__ + "static/fcc-mobile-300x250-002b88fb0c260584f4d68aab97e08baf.png";